import { writable } from "svelte/store";

export const isLoggedIn = writable(false);
export const authToken = writable({
    access_token: "",
    token_type: "",
    expires_in: 0,
    refresh_token: "",
});

// initial state of the AppData before it is populated
// lets us set up reactivity on keys before we receive the
// data from the API without a lot of if !== null checks.
export const AppData = writable({
    id: "",
    created: "",
    modified: "",
    profile: {
        emails: [
            {
                address: "",
                newsletter: false,
            },
        ],
    },
    catalog: {
        all: [],
    },
    products: {},
    subscriptions: {},
});
